import React from 'react'
import { Box, BoxProps } from '@chakra-ui/react'

const PageWrapper: React.FC<BoxProps> = props => <Box height="full" flex="1" {...props} />

export default PageWrapper
